import { useCallback } from 'react'
import { View } from 'react-native'
import styled, { useTheme } from 'styled-components'
import { FadingArrowCarousel } from '../../../elements/carousels/FadingArrowCarousel/FadingArrowCarousel'
import { ComponentError, ComponentPlaceholder } from '../../../elements/status'
import statusMsgs from '../../../elements/status/messages'
import { commonStyles } from '../../../style/commonStyles.js'
import { media, useMediaIs, useMediaSelect } from '../../../style/media'
import { PremieresContent } from '../../content-lists/PremiereFeaturedContent/PremiereFeaturedContent'
import { ListContainer as ListContainerFull } from '../ListContainer'
import { ListTitle } from '../ListTitle/ListTitle'

const ListContainer = styled(ListContainerFull)`
  padding-left: ${(props) => props.theme.spacing.small}px;
  ${media.md`
    padding-left: ${(props) => props.theme.spacing.small + props.theme.spacing.large}px;
  `};
`

const responsive = {
  lg: { slidesToShow: 2, slidesToScroll: 2 },
  md: { slidesToShow: 1, slidesToScroll: 1 },
  sm: { slidesToShow: 1, slidesToScroll: 1 },
  xs: { slidesToShow: 1, slidesToScroll: 1 },
}

export const PremiereFeaturedContent = ({
  slug,
  title,
  loading,
  error,
  items = [],
  itemProps,
  onItemChosen,
  onLayout,
  showArrows,
  ...props
}) => {
  const theme = useTheme()
  const sm = useMediaIs('sm')

  const { slidesToShow } = useMediaSelect(responsive)
  const containerHeight = PremieresContent.calcHeight(
    FadingArrowCarousel.availableWidth(theme.width) / slidesToShow,
    theme,
    sm,
  )

  const renderItem = useCallback(
    (item, _, width) =>
      item ? (
        <PremieresContent
          {...itemProps}
          channel={item}
          width={width}
          onChosen={onItemChosen}
          theme={theme}
        />
      ) : (
        <View style={{ width, height: PremieresContent.calcHeight(width, theme) }} />
      ),
    [theme, itemProps, onItemChosen],
  )

  let content
  if (loading) {
    content = <ComponentPlaceholder height={containerHeight} background="grayDark" />
  } else if (error) {
    content = (
      <ComponentError horizontal="left" height={containerHeight} {...statusMsgs.listLoadError} />
    )
  } else {
    content = (
      <FadingArrowCarousel
        {...props}
        gradientOpacity={0.5}
        height={containerHeight}
        items={items}
        scrollPositionSlug={slug}
        responsive={responsive}
        renderItem={renderItem}
        showPrev={showArrows}
        showNext={showArrows}
      />
    )
  }

  if (!items.length) return null

  return (
    <ListContainer>
      <ListTitle>{title || ' '}</ListTitle>
      <View style={commonStyles.flex1}>{content}</View>
    </ListContainer>
  )
}
